import { Component, Input } from '@angular/core';
import { File } from 'src/app/core/entities/file/file';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';

@Component({
  selector: 'app-picturesInput-control-value-view, [app-picturesInput-control-value-view]',
  templateUrl: './picturesInput-control-value-view.component.html',
  styleUrls: ['./picturesInput-control-value-view.component.scss']
})
export class PicturesInputControlValueViewComponent {

  public archived = false;
  public files: File[];

  _controlTemplate: ControlTemplate;
  @Input() set controlTemplate(controlTemplate: ControlTemplate) {
    if(controlTemplate){
      this._controlTemplate = controlTemplate;
      this.files = this.getAllPictures();
    }
  }

  constructor(
  ) {
  }

  public showPictures(): boolean {
    return this.files?.length > 0;
  }

  public showNoPicturesPossible(): boolean {
    return this._controlTemplate?.settings?.value?.picturesNotPossible;
  }

  private getAllPictures(): File[] {
    const result = new Array<File>();
    // collect requested pictures
    if (this._controlTemplate?.settings?.value?.['requestedPictures']) {
      for (const key in this._controlTemplate.settings.value['requestedPictures']) {
        const value = this._controlTemplate.settings.value['requestedPictures'][key];
        if (value?.file?.ownerState === 'ARCHIVED') {
          // if one picture is archived, the whole control is archived
          this.archived = true;
          return;
        }
        if (value?.file?.fullPath) {
          result.push(new File(value.file));
        }
      }
    }
    // collect additional pictures
    if (this._controlTemplate?.settings?.value?.['additionalPictures']) {
      this._controlTemplate?.settings?.value['additionalPictures'].forEach((element: any) => {
        if (element?.file?.ownerState === 'ARCHIVED') {
          // if one picture is archived, the whole control is archived
          this.archived = true;
          return;
        }
        if (element?.file?.fullPath) {
          result.push(new File(element.file));
        }
      });
    }
    return result;
  }
}
